import { Pet, PetsState } from "../types";

export const removePreviousPets = ({
  index,
  pets,
  petList,
}: {
  index: number;
  pets: PetsState;
  petList: Pet[];
}): PetsState => {
  const petsToRemove = petList.filter((pet, i) => i < index);
  const petsLeft = pets.filter((p) => !petsToRemove.includes(p));

  return petsLeft;
};
